
import { Inject, Injectable, DOCUMENT } from "@angular/core";
import { UiServicesLogger } from "./ui-services.logger.service";
import * as pdfjsLib from "pdfjs-dist";
import { DRCTAssets } from "@drct-web-apps/ui-types";
import { UiServiceEnvironment } from "./ui-services.environment.service";


pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs';

@Injectable({
    providedIn: 'root'
})
export class UiServicesBrochure {
    private completed = false;

    private brochureList: DRCTAssets[] = [];
    getBrochureList(): DRCTAssets[] {
        return this.brochureList;
    }

    private brochureNames = '';
    setBrochureNames(brochureNames: string) {
        this.brochureNames = brochureNames;
    }

    constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly logger: UiServicesLogger, private readonly env: UiServiceEnvironment) {
        // Empty constructor
    }

    public createBrochureList(): Promise<string> {
        const brochurePromise = new Promise<string>((resolve, reject) => {
            this.logger.log('Waiting for brochure list...');
            this.logger.log(`Brochure Names: ${this.brochureNames}`);

            if(this.completed) {
                this.logger.log('Brochure List Already Created.');
                resolve('SUCCESS');
                return;
            }
            if(this.brochureNames === null || this.brochureNames === undefined || 
               this.brochureNames.trim().length === 0) {
                this.logger.log('No Brochure Names Provided.');
                resolve('SUCCESS');
                return;
            }


            if(this.brochureNames && this.brochureNames.trim().length > 0) {
                const brochureList = this.brochureNames.split(',').map(brochure => brochure.trim());
                const promises = brochureList.map(item => {
                    return this.createBrochureImages(item);
                });   
                
                Promise.all(promises).then((results) => {
                    this.logger.log('All Brochure Images Created Successfully.');
                    this.completed = true;
                    resolve('SUCCESS');
                }).catch((error) => {
                    this.logger.error(`Error Creating Brochure Images: ${error}`);
                    reject('ERROR');
                });
            }
        });

        return brochurePromise;
    }

    public resetObject(): void {
        this.completed = false;
        this.brochureList = [];
        this.brochureNames = '';
    }



    public createBrochureImages(brochure: string): Promise<string> {
        this.logger.log('Creating Brochure Image of ' + brochure);

        return new Promise<string>((resolve, reject) => {
                    this.logger.log(`Processing Brochure: ${brochure}`);

                    const brochureInfo = brochure.split('|');
                    const brochureName = brochureInfo[0].trim();
                    const brochureDesc = brochureInfo[1]? brochureInfo[1].trim() : '';

                    const brochurePath = `${this.env.assetsPath}/uploads/brochures/${brochureName}`;
                    this.logger.log(`Brochure Path: ${brochurePath}, Description: ${brochureDesc}`);

                    const brochureDoc = pdfjsLib.getDocument(brochurePath);
                    brochureDoc.promise.then((pdfDoc) => {
                        pdfDoc.getPage(1).then((page) => {
                            const scale    = 0.5;
                            const viewport = page.getViewport({ scale });
                            const canvas   = document.createElement('canvas');
                            const context  = canvas.getContext('2d');
                            if(!context) {
                                this.logger.error(`Failed to get 2D context for canvas. Brochure ${brochureName} will not be displayed.`);
                                resolve('ERROR');
                                return;
                            }
    
                            canvas.height = viewport.height;
                            canvas.width  = viewport.width;
                  
                            page.render({
                                canvasContext: context,
                                viewport: viewport
                            }).promise.then(() => {
                                this.brochureList.push({
                                    asset_name: brochurePath,
                                    asset_desc: brochureDesc,
                                    asset_img: canvas.toDataURL()
                                });
                                this.logger.log(`Brochure ${brochureName} Image Created Successfully.`);
                                resolve('SUCCESS');
                            }).catch((error) => {
                                this.logger.error(`${brochureName} Error Rendering PDF Page: ${error}`);
                                resolve('ERROR');
                            });
                        });
                    }).catch((error) => {
                        this.logger.error(`${brochureName} Error Loading PDF Document: ${error}`);
                        resolve('ERROR');
                    });
               });
    }
}